import clsx from 'clsx';
import LinkIcon from 'components/LinkIcon/LinkIcon';

interface SitmapBtnProps {
  title: string;
  icon: string;
  to?: string;
  className?: string;
}

const SitemapBtn = ({
  icon,
  title,
  className,
  ...props
}) => (
  <button { ...props } className={clsx('sitemap-btn', className)}>
    <div className="sitemap-btn__circle">
      <span></span>
    </div>
    <LinkIcon className="sitemap-btn__icon">
      <img src={icon} alt="icon" />
    </LinkIcon>
    <p className="sitemap-btn__title">
      Galaxy "<span>{title}</span>"
    </p>
  </button>
);

export default SitemapBtn;
